<template>
	<div class="auth-wrapper auth-v1 fadeInDown primary stripped-bg">
		<div class="auth-inner" style="width: 40rem">
			<v-card class="auth-card">
				<!-- logo -->
				<v-card-title class="d-flex align-center justify-center py-2">
					<router-link to="https://sasapay.co.ke/" class="d-flex align-center">
						<v-img
							:src="require('@/assets/sp/logoo.jpg')"
							alt="logo"
							width="100"
							class="me-2"
						></v-img>
					</router-link>
				</v-card-title>

				<!-- title -->
				<v-card-text>
					<p class="text-2xl font-weight-semibold text--primary mb-2">
						Welcome to {{ appName() }}! 👋🏻
					</p>
					<p class="text-2xl font-weight-semibold text--primary mb-2">
						Please register as a sasapay user first (Download the App and
						Register) to complete your registration as a developer.
					</p>
					<v-divider />
				</v-card-text>

				<!-- login form -->
				<v-card-text>
					<v-form
						v-model="isValid"
						ref="registerForm"
						@submit.prevent="register"
					>
						<v-row>
							<v-col cols="12" md="12" sm="12">
								<v-select
									v-model="formData.country_code"
									:items="countryCodes"
									item-text="name"
									item-value="code"
									outlined
									label="Country"
									class="mb-n5"
									:rules="[rules.country_code.required]"
								>
									<template v-slot:selection="data">
										<v-avatar class="mr-2" size="20">
											<img :src="data.item.flag" alt="" />
										</v-avatar>
										<span>{{ data.item.name }}</span>
									</template>
									<template v-slot:item="data">
										<v-avatar class="mr-2" size="20">
											<img :src="data.item.flag" alt="" />
										</v-avatar>
										<span>{{ data.item.name }}</span>
									</template>
								</v-select>
							</v-col>
							<v-col cols="12" md="6" sm="12" class="mb-n5">
								<v-text-field
									v-model="formData.first_name"
									outlined
									label="First Name"
									placeholder="John"
									:rules="[rules.first_name.required]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" sm="12" class="mb-n5">
								<v-text-field
									v-model="formData.last_name"
									outlined
									label="Last Name"
									placeholder="Doe"
									:rules="[rules.last_name.required]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" sm="12" class="mb-n5">
								<v-text-field
									v-model="formData.email"
									outlined
									label="Email Address"
									placeholder="johndoe@exmaple.com"
									:rules="rules.email"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" sm="12" class="mb-n5">
								<v-text-field
									v-model="formData.mobile_number"
									outlined
									label="Phone Number"
									placeholder=""
									:rules="[rules.mobile_number.required]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="12" sm="12">
								<v-text-field
									v-model="formData.password"
									outlined
									:type="isPasswordVisible ? 'text' : 'password'"
									label="Password"
									:rules="rules.password"
									:append-icon="
										isPasswordVisible
											? icons.mdiEyeOffOutline
											: icons.mdiEyeOutline
									"
									@click:append="isPasswordVisible = !isPasswordVisible"
								></v-text-field>
							</v-col>
						</v-row>

						<div class="d-flex align-center justify-space-between flex-wrap">
							<v-checkbox
								label="Trust this device?"
								hide-details
								class="me-3 mt-1"
							>
							</v-checkbox>

							<!-- login link -->
							<router-link :to="{ name: 'Login' }" class="mt-1">
								Sign in instead?
							</router-link>
						</div>

						<v-btn v-if="!submitting" block type="submit" class="primary mt-5">
							<v-icon> mdi-lock-open-outline</v-icon> Create Account
						</v-btn>
						<v-btn v-if="submitting" block type="button" class="error">
							<i class="fa fa-refresh fa-spin loading-button-spinner"></i
							>Connecting to SasaPay Servers...
						</v-btn>
					</v-form>
				</v-card-text>
			</v-card>
		</div>

		<!-- background triangle shape  -->
		<img
			class="auth-mask-bg"
			height="173"
			:src="
				require(`@/assets/images/misc/mask-${
					$vuetify.theme.dark ? 'dark' : 'dark'
				}.png`)
			"
			alt=""
		/>

		<!-- tree -->
		<v-img
			class="auth-tree"
			width="247"
			height="185"
			src="@/assets/sp/code.png"
		></v-img>

		<!-- tree  -->
		<v-img
			class="auth-tree-3"
			width="247"
			height="185"
			src="@/assets/sp/freelancer.png"
		></v-img>
	</div>
</template>

<script>
import {
	mdiFacebook,
	mdiTwitter,
	mdiGoogle,
	mdiEyeOutline,
	mdiEyeOffOutline,
	mdiEyeRefresh,
	mdiInstagram,
} from '@mdi/js';
import { mapActions } from 'vuex';
import { appName } from '../../../environment';
import { EventBus } from '../../../../shared/utilities/event-bus';

export default {
	name: 'Register',
	data() {
		const socialLink = [
			{
				icon: mdiFacebook,
				color: '#4267b2',
				colorInDark: '#4267b2',
			},
			{
				icon: mdiTwitter,
				color: '#1da1f2',
				colorInDark: '#1da1f2',
			},
			{
				icon: mdiInstagram,
				color: '#272727',
				colorInDark: '#fff',
			},
			{
				icon: mdiGoogle,
				color: '#db4437',
				colorInDark: '#db4437',
			},
		];

		return {
			submitting: false,
			isValid: false,
			isPasswordVisible: false,
			email: '',
			password: '',
			socialLink,

			formData: {
				first_name: '',
				last_name: '',
				email: '',
				mobile_number: '',
				password: '',
				country_code: '',
			},

			rules: {
				country_code: {
					required: (value) => !!value || 'Country is required',
				},
				first_name: {
					required: (value) => !!value || 'First name is required.',
				},
				last_name: {
					required: (value) => !!value || 'Last name is required.',
				},
				email: [
					(value) => !!value || 'Please enter your email required.',
					(value) => {
						const pattern =
							/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						return (
							pattern.test(value) || 'Please provide a valid email address.'
						);
					},
				],
				mobile_number: {
					required: (value) => !!value || 'Phone number is required.',
				},
				password: [
					(value) => !!value || 'Please enter your secure password.',
					(value) => {
						const pattern =
							/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
						return (
							pattern.test(value) ||
							'Password must contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character'
						);
					},
				],
			},

			icons: {
				mdiEyeOutline,
				mdiEyeOffOutline,
				mdiEyeRefresh,
			},
			countryCodes: [
				{
					name: 'Kenya',
					code: '254',
					flag: require('@/assets/images/KE.png'),
				},
				{
					name: 'Tanzania',
					code: '255',
					flag: require('@/assets/images/TZ.png'),
				},
				{
					name: 'Uganda',
					code: '256',
					flag: require('@/assets/images/UG.png'),
				},
				{
					name: 'Somalia',
					code: '252',
					flag: require('@/assets/images/SO.png'),
				},
				{
					name: 'United States',
					code: '1',
					flag: require('@/assets/images/US.png'),
				},
			],
		};
	},
	mounted() {
		EventBus.$on('submitting', (value) => {
			this.submitting = value;
		});
	},
	methods: {
		appName() {
			return appName;
		},
		...mapActions({
			register: function (dispatch) {
				this.submitting = true;
				if (!this.isValid) {
					this.$refs.registerForm.validate();
					this.submitting = false;
				} else {
					dispatch('Auth/register', { ...this.formData });
				}
			},
		}),
	},
};
</script>
<style scoped>
.stripped-bg {
	background: url('~@/assets/sp/home-bg.png');
}
</style>
<style lang="scss" scoped>
@import '../../../plugins/default-preset/preset/pages/auth.scss';
@import '../../../plugins/default-preset/preset/pages/register.scss';
</style>
